module.exports = __webpack_public_path__ + "img/brush.990654de.svg";